import React from "react";
import { NavLink } from 'react-router-dom';

import ImageDecorator from "../ImageDecorator/ImageDecorator";

import introDescriptionOneImg from "../../../shared/images/intro/IntroDescriptionOne.jpg"
import introDescriptionTwoImg from "../../../shared/images/intro/IntroDescriptionTwo.jpg"

import "./IntroDescriptionOne.css"


const IntroDescriptionOne = function (props) {
    return (
        <React.Fragment>

            <div className="intro-description-One-flex-container" ref={props.reference}>
                <div className="intro-descript-One-flex-left">
                    <h2 className="intro-intro"><span>Willkommen bei</span></h2>
                    <h1 className="intro-name"><span>Combat Sports Lübeck</span></h1>
                    <h2 className="intro-intro"><span>Die Adresse für</span></h2>
                    <div className="intro-title">
                        <div className="intro-title-wrapper">
                            <div className="intro-title-item"><NavLink to="/sparten" exact="true">Muay Thai</NavLink></div>
                            {/* <div className="intro-title-item">Mixed Martial Arts</div> */}
                            <div className="intro-title-item"><NavLink to="/sparten" exact="true">Kettlebells</NavLink></div>
                            <div className="intro-title-item"><NavLink to="/sparten" exact="true">Powerlifting</NavLink></div>
                            <div className="intro-title-item"><NavLink to="/sparten" exact="true">Bodybuilding</NavLink></div>
                        </div>
                    </div>

                    <div className="blockquote-wrapper">
                        <div className="blockquote">
                            <h1>
                                Du bist auf der Suche nach einem <span>Trainingskonzept</span>, welches Dir hilft Deine <span>Ziele</span> zu verfolgen und zu erreichen? Einer <span>positiven Trainingsatmosphäre</span> geprägt von Motivation, Loyalität und Ehrlichkeit? Du möchtest <span>besser</span>, <span>stärker</span>, <span>definierter</span> und <span>fitter</span> werden oder einen Ausgleich schaffen zum stressigen Alltag? Dann bist Du hier richtig. <span>Überzeug Dich selbst!</span>
                            </h1>
                            <h4>Andreas Wiechmann<br /><em>Trainer Combat Sports HL</em></h4>
                        </div>
                    </div>

                </div>
                <div className="intro-descript-One-flex-right">
                    <ImageDecorator image={introDescriptionTwoImg} />
                </div>




            </div>





        </React.Fragment >
    );
}

export default IntroDescriptionOne;